<template>
  <div id="dailyRoutineParent">
    <div class="container" style="text-align: left; padding: 20px; background: #ffffff">
      <h4>{{ lang('Daily Routine') }}</h4>

      <div class="row" style="margin: 0px">
        <div class="pdr-student-selection-container" style="width: 48%">
          <label>Select Child</label>
          <select class="form-control" v-model="selectedStud" @change="getDailyRoutine()">
            <option v-for="stud in parStudentsInfo" :value="stud.StudentID">
              {{ stud.StudentFirstName + stud.StudentMiddleName + stud.StudentLastName }}
            </option>
          </select>
        </div>

        <div class="pdr-selection-date-container" style="width: 48%; margin-left: auto">
          <label>Select Date</label>
          <input class="form-control" type="date" v-model="selectedDate" @change="changedDate()" />
        </div>
      </div>

      <div>
        <label>{{ lang('Activity') }}</label>

        <div class="daily-timeline" v-if="studArrDailyRoutineList.length > 0">
          <div
            class="daily-timeline__item"
            v-for="(item, i) in studArrDailyRoutineList"
            v-bind:value="item.drID"
            :key="item.ID"
            ref="dailyRoutineList_Update"
            :class="item.MainReferenceType"
          >
            <div class="daily-item_image" style="text-align: center">
              <img :src="getIcon(item)" />
            </div>

            <div class="daily-item_desc">
              <div class="row daily-desc_wrap">
                <div class="col-md-9">
                  <label class="DrReferenceType">{{ lang(item.DrReferenceType) }}</label>

                  <el-input class="drp-remarks" :rows="3" disabled type="textarea" :placeholder="lang('Remark')" v-model="item.DrRemark" ref="refDrRemark">
                  </el-input>
                </div>

                <div class="col-md-3 date">
                  <label class="text-center daily-date-strong"
                    ><strong>{{ item.DrCreatedOn_convert }}</strong></label
                  >

                  <label class="text-center" v-if="item.MainReferenceType !== 'Poop'">
                    <strong v-if="item.MainReferenceType === 'Rest'">{{ lang('From') }}:</strong>
                    <strong v-else>{{ lang('On') }}:</strong>
                    {{ item.DrStartTime_convert }}
                  </label>

                  <label class="text-center" v-if="item.MainReferenceType === 'Rest'"
                    ><strong>{{ lang('To') }}:</strong> {{ item.DrEndTime_convert }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="studArrDailyRoutineList.length <= 0">
          <img src="../assets/empty-list.jpg" style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import moment from 'moment'
import { lang } from '../locale/index'

export default {
  name: 'DailyRoutineParent',
  components: {},
  data() {
    return {
      studArrDailyRoutineList: [],
      selectedDate: '',
      selectedStud: '',
      parStudentsInfo: [],
      hardCodeItem: [],
    }
  },
  async mounted() {
    await this.isMobile()
    await this.LoadParentInfo()
    await this.loadHardCodeArray()
    // await this.getDailyRoutine();
  },
  methods: {
    lang,

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0
    },

    isMobile() {
      if (window.innerWidth <= 760) {
        this.isBigScreenWidth = false
      } else {
        this.isBigScreenWidth = true
      }
    },

    getIcon(value) {
      if (value.MainReferenceType === 'Poop') {
        var arrType = value.DrReferenceType.split(',')
        return require('../img/' + this.hardCodeItem[arrType[0]])
      } else {
        return require('../img/' + this.hardCodeItem[value.DrReferenceType])
      }
    },

    async loadHardCodeArray() {
      this.hardCodeItem = {
        'Rest|Nap': 'Nap.png',
        'Rest|Sleep': 'Sleep.png',

        'Feed|Bottle-Type|Formula': 'Formula.png',
        'Feed|Bottle-Type|Breast Milk': 'Breast Milk.png',
        'Feed|Solid': 'Solid.png',
        'Feed|Latch On|Left': 'Left.png',
        'Feed|Latch On|Right': 'Right.png',
        'Feed|Menu': 'Menu.png',

        'Poop|Texture|Creamy': 'Creamy.png',
        'Poop|Texture|Firm': 'Firm.png',
        'Poop|Texture|Hard': 'Hard.png',
        'Poop|Texture|Watery': 'Watery.png',
        'Poop|Color|Brown': 'Brown.png',
        'Poop|Color|Tan': 'Tan.png',
        'Poop|Color|Yellow': 'Yellow.png',
        'Poop|Color|Green': 'Green.png',
        'Poop|Color|Black': 'Black.png',

        'Hygiene|Diaper change': 'Diaper change.png',
        'Hygiene|Shower&Diaper change': 'Shower&Diaper Change.png',
        'Hygiene|Shower': 'Shower.png',
      }
    },

    async LoadParentInfo() {
      try {
        if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
          const response = await DataSource.shared.getParentStudentsInfo(Cookies.get('userIDSession'))
          if (response) {
            if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No record found',
              })
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Please try again later',
              })
            } else {
              // this.parentInfo = response.Parent[0];
              this.parStudentsInfo = response.Students
            }
          }

          // console.log(this.parStudentsInfo, "sadasd");
        }
      } catch (e) {
        this.results = e
      }
    },

    getDailyRoutine() {
      this.studArrDailyRoutineList = []
      try {
        if (this.isNull(this.selectedDate)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select date!',
          })
          return
        } else if (this.isNull(this.selectedStud)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select child!',
          })
          return
        }

        const response = DataSource.shared.getDailyRoutineByStudentIDwithDate(this.selectedStud, this.selectedDate)

        response.then(resp => {
          if (resp.code === '2') {
            console.log(resp.code)
          } else if (resp.code === '88') {
            console.log(resp.code)
          } else if (resp.code === '99') {
            console.log(resp.code)
          } else {
            this.studArrDailyRoutineList = resp.Table
          }

          // console.log(this.studArrDailyRoutineList, "asd");
        })
      } catch (e) {
        this.results = e
      }
    },

    changedDate() {
      this.getDailyRoutine()
    },
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
}
</script>

<style scoped></style>

<style>
#dailyRoutineParent .drp-remarks textarea {
  resize: none;
}
</style>
